// K线图形列表
const kLineList = [
    {
        label: '早晨之星',
        value: 2
    },
    {
        label: '黄昏之星',
        value: 3
    },
    {
        label: '看涨吞没',
        value: 4
    },
    {
        label: '看跌吞没',
        value: 5
    },
    {
        label: '上涨旗形',
        value: 6
    },
    {
        label: '下跌旗形',
        value: 7
    },
    {
        label: '双重顶',
        value: 8
    },
    {
        label: '双重底',
        value: 9
    },
]

// 成交量类型列表
const measureList = [
    {
        label: '无',
        value: 0
    },
    {
        label: '放量',
        value: 1
    },
    {
        label: '缩量',
        value: 2
    }
]

const state = {
    kLineList,
    measureList,
    kLineIndex: 2,
    measureType: 0,
    searchList: [],
    watchList: [],
    searchResults: []
}

const getters = {
    getGraphic: (state) => (value) => {
        return state.kLineList.find(item => item.value === value)?.label || '-'
    },
    getVariety: (state) => (value) => {
        return state.measureList.find(item => item.value === value)?.label || '-'
    },
    searchResults: state => state.searchResults
}

const mutations = {
    SET_KLINE_INDEX(state, index) {
        state.kLineIndex = index
    },
    SET_MEASURE_TYPE(state, type) {
        state.measureType = type
    },
    SET_SEARCH_LIST(state, list) {
        state.searchList = list
    },
    SET_WATCH_LIST(state, list) {
        state.watchList = list
    },
    SET_SEARCH_RESULTS(state, results) {
        state.searchResults = results
    }
}

const actions = {
    setKLineIndex({ commit }, index) {
        commit('SET_KLINE_INDEX', index)
    },
    setMeasureType({ commit }, type) {
        commit('SET_MEASURE_TYPE', type)
    },
    setSearchList({ commit }, list) {
        commit('SET_SEARCH_LIST', list)
    },
    setWatchList({ commit }, list) {
        commit('SET_WATCH_LIST', list)
    },
    setSearchResults({ commit }, results) {
        commit('SET_SEARCH_RESULTS', results)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
} 